<template>
    <div class="banner position-relative z-0">
        <div class="container position-absolute top-50 start-50 translate-middle z-2">
            <div class="border bg-white bg-opacity-25 rounded-5 px-4 py-2 swiper-prev position-absolute start-0 ms-3 text-white border-0"><i class="fas fa-chevron-left"></i></div>
            <div class="border bg-white bg-opacity-25 rounded-5 px-4 py-2 swiper-next position-absolute end-0 me-3 text-white border-0"><i class="fas fa-chevron-right"></i></div>
        </div>
        <swiper-container :slides-per-view="1" :navigation-next-el="'.banner .swiper-next'" :navigation-prev-el="'.banner .swiper-prev'">
            <swiper-slide v-for="banner in banners" class="ratio ratio-10x3">
                <img :src="banner.image_path" alt="" class="img-fluid w-100 h-100 object-fit-cover">
                <div class="d-flex bg-opacity-50 bg-evil-cigar">
                    <div class="container my-auto">
                        <div class="mx-5">
                            <div class="text-white text-center">Find cars for sale and for rent near you</div>
                            <h1 class="ff-dsb fs-52 text-white text-center">Find Your Next Vehicle</h1>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper-container>
    </div>
</template>
<script setup>
    import { register } from 'swiper/element/bundle';

    register();

    defineProps({ banners: Array })

</script>